import { inject, provideAppInitializer } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateService } from '@ngx-translate/core';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import { ConfirmationService, MessageService } from 'primeng/api';
import { PrimeNG, providePrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';
import { LangService } from '@shared/services';

const appThemePreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

export const uiProviders = [
  provideAppInitializer(() => {
    const langService = inject(LangService);
    const translateService = inject(TranslateService);
    const primengConfig = inject(PrimeNG);

    langService.init();
    return firstValueFrom(translateService.get('primeng')).then((res) => {
      primengConfig.setTranslation(res);
    });
  }),
  providePrimeNG({
    theme: { preset: appThemePreset, options: { darkModeSelector: '.app-dark' } },
  }),
  ConfirmationService,
  MessageService,
  provideAnimationsAsync(),
];
